// removed by extract-text-webpack-plugin
module.exports = {"taskTemplateInfo":"TaskTemplateInfo__taskTemplateInfo__2Doz9","info":"TaskTemplateInfo__info__2Ve04","taskTemplateId":"TaskTemplateInfo__taskTemplateId__28QxU","media":"TaskTemplateInfo__media__jo3hy"};


//////////////////
// WEBPACK FOOTER
// ./src/Components/Pages/TaskTemplateDetailView/TaskTemplateInfo/TaskTemplateInfo.scss
// module id = 1882
// module chunks = 0